'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _TypingStatusIndicator = require('./TypingStatusIndicator');

var _TypingStatusIndicator2 = _interopRequireDefault(_TypingStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TypingStatusIndicator: _TypingStatusIndicator2.default
    },
    props: ['buffer'],
    computed: {
        users: function users() {
            if (this.buffer.isQuery()) {
                var network = this.$state.getActiveNetwork();
                var user = this.$state.getUser(network.id, this.buffer.name);
                return user ? (0, _defineProperty3.default)({}, user.nick, user) : {};
            }
            return this.buffer.users;
        },
        typingUsers: function typingUsers() {
            var _this = this;

            var myNick = this.$state.getActiveNetwork().nick;
            return (0, _values2.default)(this.users).filter(function (u) {
                return u.nick !== myNick && u.typingStatus(_this.buffer.name).status;
            });
        }
    },
    methods: {
        userColour: function userColour(user) {
            return user && this.buffer.setting('colour_nicknames_in_messages') ? user.getColour() : '';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingUsersList"]
window._kiwi_exports.components.TypingUsersList = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TypingUsersList.vue
// module id = 6t4W
// module chunks = 1